import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class SettledUnsettledFilter extends Component {
    state = {
        isSettledLists:[],
        isSettledValue: '',
        isSettledLoading: true
    };
    componentDidMount(){
        this.getSettled();
    }

    resetSettledFilter(){
        this.setState({
        isSettledValue: [],
        })
    }
    getSettled(){
        axios.get(config.get('API_URL')+'/filters/get-settled-unsettled/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((settled, index) => {
                    this.state.isSettledLists.push({value: settled.settled_unsettled_code, label: settled.settled_unsettled_display_name})
                });
            }
            this.setState({
                loading:false,
                isSettledLoading: false
            })
        });

    }
    changeIsSettled(optionSelected){
        let value='';
        let settledArray = [];
        if (optionSelected.length < 1) {
            value = null;
            settledArray = "";
        }
        else{
            optionSelected.map((mids, i) => {
                settledArray.push(mids.value)

            });
        }
        this.props.onSelectSettled(optionSelected,settledArray);
        this.setState({
            isSettledValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="Is_Settled"
                isMulti
                value={this.state.isSettledValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeIsSettled.bind(this)}
                options={this.state.isSettledLists}
                placeholderButtonLabel="All"
            />
        );

    }
}
export default SettledUnsettledFilter;